import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={31}
    height={31}
    viewBox="0 0 31 31"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#070A7A'}
      d="M30.44 15.481a1 1 0 0 0-2 0h2Zm-3.476-5.865a1 1 0 1 0 1.792-.889l-1.792.889ZM16.24 10.742a1 1 0 1 0-2 0h2Zm1.443 10.167a1 1 0 0 0 1.414-1.414l-1.414 1.414ZM28.86 4.432a1 1 0 1 0-2 0h2Zm-1 4.73v1a1 1 0 0 0 1-1h-1Zm-4.73-1a1 1 0 1 0 0 2v-2Zm6.31 7.32h-1c0 7.287-5.912 13.2-13.2 13.2v2c8.392 0 15.2-6.808 15.2-15.2h-1Zm-14.2 14.2v-1c-7.288 0-13.2-5.913-13.2-13.2h-2c0 8.392 6.808 15.2 15.2 15.2v-1Zm-14.2-14.2h1c0-7.288 5.912-13.2 13.2-13.2v-2C6.848.281.04 7.088.04 15.481h1Zm14.2-14.2v1c5.178 0 9.563 2.974 11.724 7.334l.896-.445.896-.444c-2.479-5-7.534-8.446-13.516-8.446v1Zm0 9.46h-1v5h2v-5h-1Zm0 5h-1c0 1.103.434 2.158 1.213 2.937l.707-.707.707-.707a2.148 2.148 0 0 1-.627-1.523h-1Zm.92 2.23-.707.707 2.23 2.23.707-.707.707-.707-2.23-2.23-.707.707Zm11.7-13.54h-1v4.73h2v-4.73h-1Zm0 4.73v-1h-4.73v2h4.73v-1Z"
    />
  </Svg>
);
export default SvgComponent;
